module.exports = __webpack_public_path__ + "img/alertErrorWhite.967e952d.svg";